"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkoutType = exports.WorkoutStatus = void 0;
var WorkoutStatus;
(function (WorkoutStatus) {
    WorkoutStatus[WorkoutStatus["notStarted"] = 0] = "notStarted";
    WorkoutStatus[WorkoutStatus["inProgress"] = 1] = "inProgress";
    WorkoutStatus[WorkoutStatus["complete"] = 2] = "complete";
})(WorkoutStatus = exports.WorkoutStatus || (exports.WorkoutStatus = {}));
var WorkoutType;
(function (WorkoutType) {
    WorkoutType[WorkoutType["mobility"] = 0] = "mobility";
    WorkoutType[WorkoutType["normal"] = 1] = "normal";
})(WorkoutType = exports.WorkoutType || (exports.WorkoutType = {}));
//# sourceMappingURL=Workout.js.map